import AOS from 'aos';
import 'aos/dist/aos.css';

export default function animateOnScroll() {
    AOS.init({
        duration: 800,
        once: true  
    });
}